
import Balance from '../../../../../assets/Balance';
import Fees from '../../../../../assets/common/Fees';
import Pending from '../../../../../assets/common/Pending';
import Dollar from '../../../../../assets/common/Dollar';
import { Spin } from 'antd';

const PaymentMethodInfo = ({ paymentMethod, walletBalance, isLoading, selectedPaymentMethod }) => {

    const infoCards = [
        {
            title: 'Wallet Balance',
            value: walletBalance?.toFixed(2) || '0.00',
            prefix: '$ ',
            color: 'bg-[#FFE2E3]',
            icon: <Balance color="#FF4C51" />
        },
        {
            title: 'Transaction Fees',
            value: paymentMethod?.fees || 'Free',
            suffix: paymentMethod?.fees,
            color: "bg-[#E9E7FD]",
            icon: <Fees color="#7367F0" />
        },
        {
            title: 'Processing Time',
            value: selectedPaymentMethod?.processingTime || '24 H',
            color: 'bg-[#D6F4F8]',
            icon: <Pending color="#00BAD1" />
        },
        {
            title: 'Minimum Withdrawal',
            value: paymentMethod?.minAmount,
            prefix: '$ ',
            color: 'bg-[#FFF0E1]',
            icon: <Dollar color="#FF9F43" />
        },
        {
            title: 'Maximum Withdrawal',
            value: paymentMethod?.maxAmount,
            prefix: '$ ',
            color: 'bg-[#DDF6E8]',
            icon: <Dollar color="#28C76F" />
        },
    ];
    return (
        <div className='border-2 border-light rounded-lg p-5'>
            {isLoading ? <div className='flex justify-center items-center'>
                <Spin />
            </div> :
                <div className="grid sm:grid-cols-3 xl:grid-cols-5 gap-5">
                    {infoCards?.map((card, index) => (
                        <div key={index} className='flex items-center gap-3'>
                            <div className={`flex justify-center items-center ${card?.color} w-[45px] h-[45px] rounded-lg`}>
                                {card?.icon}
                            </div>
                            <div>
                                <p className='sm:text-xl text-md'>{card?.prefix}{card?.value}{card?.suffix}</p>
                                <p className='text-sm font-medium text-gray-500 capitalize'>{card?.title}</p>
                            </div>
                        </div>
                    ))}
                </div>}
        </div>
    )
}

export default PaymentMethodInfo